import React from 'react';
import { Box, Grid } from '@mui/material';
import CourseCard from '../CourseCard';

export default function InteractiveList({ information = [] }) {
  return (
    <Box sx={{ width: '100%' }}>
      <Grid container justifyContent="space-between" sx={{ width: '100%' }}>
        {information.map(course => (
          <CourseCard key={course.id} course={course} />
        ))}
      </Grid>
    </Box>
  );
}
